/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Card } from "./Card";
import { Message } from "./Message";
import * as t from "io-ts";

// required attributes
const PanResponseR = t.interface({});

// optional attributes
const PanResponseO = t.partial({
  data: t.readonlyArray(Card, "array of Card"),

  messages: t.readonlyArray(Message, "array of Message"),

  requestId: t.string
});

export const PanResponse = t.intersection(
  [PanResponseR, PanResponseO],
  "PanResponse"
);

export type PanResponse = t.TypeOf<typeof PanResponse>;
